var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRawMaterials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185,
    height: 123.772,
    viewBox: "0 0 185 123.772",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raw-Materials-blank",
    transform: "translate(-722 -532.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3741",
    "data-name": "Path 3741",
    d: "M122.911,30c-11.668-.4-22.78-4.172-33.391-8.293S68.4,13.025,57.01,10.842c-7.325-1.4-15.7-1.6-21.6,2.318-5.681,3.786-7.516,10.3-8.5,16.355-.743,4.554-1.179,9.347.855,13.611,1.413,2.96,3.919,5.448,5.654,8.284,6.034,9.865,1.769,22.03-4.768,31.662-3.065,4.518-6.625,8.834-8.992,13.638s-3.461,10.328-1.39,15.243c2.052,4.868,6.943,8.516,12.241,11.085,10.761,5.219,23.436,6.712,35.805,7.559,27.372,1.871,54.888,1.062,82.332.249,10.157-.3,20.357-.6,30.348-2.174,5.549-.873,11.276-2.257,15.306-5.6a12.816,12.816,0,0,0,2.953-16.743c-5.747-8.924-21.634-11.139-25.656-20.714-2.21-5.271.059-11.141,3.274-16.029C181.76,59.1,193.314,49.9,193.921,37.916c.418-8.232-5.136-16.476-13.725-20.372-9-4.083-21.486-3.57-28.124,3.189C145.231,27.686,133.214,30.363,122.911,30Z",
    transform: "translate(707.833 522.375)",
    fill: "#2699fb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "materials",
    transform: "translate(722 561.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Car",
    transform: "translate(-5.6 -3.131)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3107",
    "data-name": "Rectangle 3107",
    width: 8.01,
    height: 3.13,
    transform: "translate(28.975 90.934) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_48",
    "data-name": "Union 48",
    d: "M0,4.008a4,4,0,0,1,6.764-2.9H16.986V.7h27.8v.828H42.08a3.5,3.5,0,1,1-5.389,3.084H7.971A4.007,4.007,0,0,1,0,4.008Z",
    transform: "translate(20.412 89.458)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3817",
    "data-name": "Path 3817",
    d: "M0,0H.046A.875.875,0,0,1,.921.875h0a.875.875,0,0,1-.875.875H0V0Z",
    transform: "translate(65.156 92.316) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6959",
    "data-name": "Group 6959",
    transform: "translate(22.309 91.358)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1008",
    "data-name": "Ellipse 1008",
    cx: 2.108,
    cy: 2.108,
    r: 2.108,
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1010",
    "data-name": "Ellipse 1010",
    cx: 1.841,
    cy: 1.841,
    r: 1.841,
    transform: "translate(36.449 0.726)",
    fill: "#e2e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6958",
    "data-name": "Group 6958",
    transform: "translate(19.17 80.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_49",
    "data-name": "Union 49",
    d: "M9.668,11.924H8.883a4.56,4.56,0,0,0-3.543-1.76A4.568,4.568,0,0,0,1.8,11.924H0l1.75-4.869L9.2,5.584,11.418,0h7.088V11.924Z",
    transform: "translate(0)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3109",
    "data-name": "Rectangle 3109",
    width: 4.051,
    height: 4.051,
    transform: "translate(17.032 4.79) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3815",
    "data-name": "Path 3815",
    d: "M28.238,83.428h2.578V79.377h-1.1Z",
    transform: "translate(-18.296 -78.591)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "materials-2",
    "data-name": "materials",
    transform: "translate(40.334 79.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_45",
    "data-name": "Union 45",
    d: "M1.35,4.5V3.375H0V2.246H1.574V1.121h2.7V0H30.785V1.129h-2.7V2.246H26.518V3.375h1.348V4.5Z",
    transform: "translate(15.954)",
    fill: "#00b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_46",
    "data-name": "Union 46",
    d: "M0,4.273V3.146H1.574V2.252H.451V1.129H2.023V0H28.539V1.129H26.967v.893H28.09V3.146H26.518V4.273Z",
    transform: "translate(0 6.296)",
    fill: "#00b0ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6957",
    "data-name": "Group 6957",
    transform: "translate(20.317 60.727)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3105",
    "data-name": "Rectangle 3105",
    width: 0.921,
    height: 6.537,
    transform: "translate(18.6 20.448) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3106",
    "data-name": "Rectangle 3106",
    width: 0.921,
    height: 36.768,
    transform: "matrix(-0.376, -0.927, 0.927, -0.376, 18.023, 14.681)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3110",
    "data-name": "Rectangle 3110",
    width: 0.921,
    height: 1.749,
    transform: "translate(15.701 28.504) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3816",
    "data-name": "Path 3816",
    d: "M0,0H.046A.875.875,0,0,1,.921.875h0a.875.875,0,0,1-.875.875H0V0Z",
    transform: "translate(10.591 24.776) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3111",
    "data-name": "Rectangle 3111",
    width: 1.933,
    height: 13.948,
    transform: "translate(19.015 31.956) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3113",
    "data-name": "Rectangle 3113",
    width: 0.921,
    height: 0.368,
    transform: "translate(10.958 25.052) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3819",
    "data-name": "Path 3819",
    d: "M98.461,128.142a.092.092,0,0,1-.023-.072l1.27-12.007a.092.092,0,0,1,.091-.082h0a.092.092,0,0,1,.091.082l1.373,11.982a.092.092,0,0,1-.091.1l-2.643.025h0A.092.092,0,0,1,98.461,128.142ZM99.8,116.914l-1.171,11.073,2.437-.023Z",
    transform: "translate(-47.729 -104.779)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3820",
    "data-name": "Path 3820",
    d: "M0,0H.046A.875.875,0,0,1,.921.875h0a.875.875,0,0,1-.875.875H0V0Z",
    transform: "translate(0.619 26.788) rotate(20.717)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3114",
    "data-name": "Rectangle 3114",
    width: 0.921,
    height: 13.442,
    transform: "translate(52.573 13.45) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1011",
    "data-name": "Ellipse 1011",
    cx: 1.289,
    cy: 1.289,
    r: 1.289,
    transform: "translate(16.852 12.808)",
    fill: "#3f3d56"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3821",
    "data-name": "Path 3821",
    d: "M110.335,70.09a3.2,3.2,0,0,1,2.1.782,3.2,3.2,0,0,1,1.412-.062,3.21,3.21,0,0,1,5.852,1.821H107.2A3.211,3.211,0,0,1,110.335,70.09Z",
    transform: "translate(-31.973 -45.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3822",
    "data-name": "Path 3822",
    d: "M91.527,80.2a3.022,3.022,0,0,1,1.983.739,3.024,3.024,0,0,1,1.334-.059,3.034,3.034,0,0,1,5.533,1.722H88.559a3.035,3.035,0,0,1,2.968-2.4Z",
    transform: "translate(-31.973 -45.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3823",
    "data-name": "Path 3823",
    d: "M72.723,63.523a3.144,3.144,0,0,1,2.064.769,3.146,3.146,0,0,1,1.388-.061,3.157,3.157,0,0,1,5.757,1.792h-12.3a3.158,3.158,0,0,1,3.088-2.5Z",
    transform: "translate(-31.973 -45.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3824",
    "data-name": "Path 3824",
    d: "M153.921,95.288v25.6h9.956V94.933l-2.311.083V89.777h-1.676l-.276-11.6a3.251,3.251,0,0,0,1.152-2.71,4.442,4.442,0,0,0-.122-1.042,2.132,2.132,0,0,0,.23-2.6,2.133,2.133,0,1,0,2.764-3.249,2.134,2.134,0,1,0-2.872-2c0,.031,0,.062,0,.093a2.135,2.135,0,0,0-2.734,1.718,2.133,2.133,0,1,0-1.534,3.92c0,.015,0,.031,0,.046a10.371,10.371,0,0,0,.753,1.729,4.309,4.309,0,0,0-.22,1.382,3.251,3.251,0,0,0,1.152,2.71l-.276,11.6h-1.676v5.429Zm6.217-24.445h.006l.092,0q.029.095.066.185a2.142,2.142,0,0,0-.163-.183Z",
    transform: "translate(-31.973 -45.036)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3119",
    "data-name": "Rectangle 3119",
    width: 30.222,
    height: 34.963,
    transform: "translate(146.689 94.074) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3120",
    "data-name": "Rectangle 3120",
    width: 8.148,
    height: 7.111,
    transform: "translate(135.652 94.074) rotate(180)",
    fill: "#e2e2e2",
    opacity: 0.351
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3825",
    "data-name": "Path 3825",
    d: "M138.367,58.144c0,.026,0,.051,0,.077a3.544,3.544,0,0,0,1.078,2.549,3.551,3.551,0,0,0,.178.332,7.179,7.179,0,0,0-.367,2.3c0,2.7,1.393,4.889,3.111,4.889s3.111-2.189,3.111-4.889a7.4,7.4,0,0,0-.2-1.737,3.553,3.553,0,0,0,.383-4.327,3.555,3.555,0,1,0,4.607-5.415,3.556,3.556,0,1,0-4.787-3.336c0,.052,0,.1,0,.155a3.558,3.558,0,0,0-4.556,2.863,3.556,3.556,0,1,0-2.557,6.534Zm6.072-2.441c.051,0,.1,0,.153,0q.048.158.11.309a3.564,3.564,0,0,0-.272-.305Z",
    transform: "translate(-31.973 -45.036)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3826",
    "data-name": "Path 3826",
    d: "M140.587,92.592h3.556l-.127-5.333v0L143.551,67.7a2.274,2.274,0,0,1-2.371,0l-.465,19.555v0Z",
    transform: "translate(-31.973 -45.036)",
    fill: "#00b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3827",
    "data-name": "Path 3827",
    d: "M102.1,51.407V94.074h16.591V50.814l-3.851.137V42.223h-8.889v9.047Z",
    fill: "#00b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3828",
    "data-name": "Path 3828",
    d: "M180.738,58.144c0,.026,0,.051,0,.077a3.544,3.544,0,0,0,1.078,2.549,3.551,3.551,0,0,0,.178.332,7.18,7.18,0,0,0-.367,2.3c0,2.7,1.393,4.889,3.111,4.889s3.111-2.189,3.111-4.889a7.4,7.4,0,0,0-.2-1.737,3.553,3.553,0,0,0,.383-4.327,3.555,3.555,0,1,0,4.607-5.415,3.556,3.556,0,1,0-4.787-3.336c0,.052,0,.1,0,.155a3.558,3.558,0,0,0-4.556,2.863,3.556,3.556,0,1,0-2.557,6.534ZM186.81,55.7c.051,0,.1,0,.153,0q.048.158.11.309a3.56,3.56,0,0,0-.272-.305Z",
    transform: "translate(-31.973 -45.036)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3829",
    "data-name": "Path 3829",
    d: "M182.958,92.592h3.556L185.921,67.7a3.5,3.5,0,0,1-2.37,0Z",
    transform: "translate(-31.973 -45.036)",
    fill: "#00b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3830",
    "data-name": "Path 3830",
    d: "M144.467,51.407V94.074H161.06V50.814l-1.363.049-2.49.088V42.223h-8.889v9.047Z",
    fill: "#00b0ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6956",
    "data-name": "Group 6956",
    opacity: 0.201
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3121",
    "data-name": "Rectangle 3121",
    width: 4.099,
    height: 4.099,
    transform: "translate(140.186 67.43) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3122",
    "data-name": "Rectangle 3122",
    width: 4.099,
    height: 4.099,
    transform: "translate(133.627 67.43) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3123",
    "data-name": "Rectangle 3123",
    width: 4.099,
    height: 4.099,
    transform: "translate(127.068 67.43) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3124",
    "data-name": "Rectangle 3124",
    width: 4.099,
    height: 4.099,
    transform: "translate(140.186 73.988) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3125",
    "data-name": "Rectangle 3125",
    width: 4.099,
    height: 4.099,
    transform: "translate(133.627 73.988) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3126",
    "data-name": "Rectangle 3126",
    width: 4.099,
    height: 4.099,
    transform: "translate(127.068 73.988) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3127",
    "data-name": "Rectangle 3127",
    width: 4.099,
    height: 4.099,
    transform: "translate(140.186 80.547) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3128",
    "data-name": "Rectangle 3128",
    width: 4.099,
    height: 4.099,
    transform: "translate(133.627 80.547) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3129",
    "data-name": "Rectangle 3129",
    width: 4.099,
    height: 4.099,
    transform: "translate(127.068 80.547) rotate(180)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6955",
    "data-name": "Group 6955",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3130",
    "data-name": "Rectangle 3130",
    width: 4.099,
    height: 4.099,
    transform: "translate(112.441 65.791) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3131",
    "data-name": "Rectangle 3131",
    width: 4.099,
    height: 4.099,
    transform: "translate(112.441 72.35) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3132",
    "data-name": "Rectangle 3132",
    width: 4.099,
    height: 4.099,
    transform: "translate(112.441 78.908) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3133",
    "data-name": "Rectangle 3133",
    width: 4.099,
    height: 4.099,
    transform: "translate(112.441 85.467) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3134",
    "data-name": "Rectangle 3134",
    width: 4.099,
    height: 4.099,
    transform: "translate(154.778 65.791) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3135",
    "data-name": "Rectangle 3135",
    width: 4.099,
    height: 4.099,
    transform: "translate(154.778 72.35) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3136",
    "data-name": "Rectangle 3136",
    width: 4.099,
    height: 4.099,
    transform: "translate(154.778 78.908) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3137",
    "data-name": "Rectangle 3137",
    width: 4.099,
    height: 4.099,
    transform: "translate(154.778 85.467) rotate(180)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3138",
    "data-name": "Rectangle 3138",
    width: 182,
    height: 0.41,
    transform: "translate(0 93.93)",
    fill: "#3f3d56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRawMaterials);
export default __webpack_public_path__ + "static/media/raw-materials.6228802f925567b47509d02f1f3f1b62.svg";
export { ForwardRef as ReactComponent };